import { render, staticRenderFns } from "./FormularioCtrlTipoSolicitacaoComponent.vue?vue&type=template&id=1232022e"
import script from "./FormularioCtrlTipoSolicitacaoComponent.vue?vue&type=script&lang=js"
export * from "./FormularioCtrlTipoSolicitacaoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports